import { createReducer, on } from '@ngrx/store';
import { Quiz } from '../models';
import { quizActions } from '../actions/quizes.actions';

export interface SingleQuizState {
    quiz: Quiz | null;
    loading: boolean;
    loaded: boolean | null;
}

export type QuizState = Record<string, SingleQuizState>;

const initialSingleState: SingleQuizState = {
    quiz: null,
    loading: false,
    loaded: null,
};

const initialState: QuizState = {};

const getQuizState = (state: QuizState, id: string): SingleQuizState => {
    return state[id] ?? { ...initialSingleState };
};

export const quizReducer = createReducer(
    initialState,

    // Get Quiz
    on(
        quizActions.getQuiz,
        (state, { id }): QuizState => ({
            ...state,
            [id]: { ...getQuizState(state, id), loading: true },
        }),
    ),
    on(
        quizActions.getQuizSuccess,
        (state, { payload }): QuizState => ({
            ...state,
            [payload.id]: {
                ...getQuizState(state, payload.id),
                quiz: payload,
                loading: false,
                loaded: true,
            },
        }),
    ),
    on(
        quizActions.getQuizError,
        (state, { id }): QuizState => ({
            ...state,
            [id]: {
                ...getQuizState(state, id),
                loading: false,
                loaded: false,
            },
        }),
    ),

    // Clear
    on(quizActions.clear, (state, { id }): QuizState => {
        const { [id]: _, ...rest } = state;
        return rest;
    }),
    on(quizActions.clearAll, (): QuizState => initialState),
);
